import { useState, view } from '@esui/core';
import { DemoPage, Section } from '../@demo/utils.js';
import { Button } from '../button/index.js';
import { CircularProgressFourColor } from '../circular-progress-four-color/index.js';
import { CircularProgress } from './index.js';

export const [CircularProgressDemo] = view('circular-progress-demo', {
  template() {
    const [isClosed, setIsClosed] = useState(false);

    return DemoPage(
      Section(
        '',
        Button('Toggle')
          .raised()
          .onClick(() => setIsClosed(closed => !closed)),
        CircularProgress(0.4).closed(isClosed)
      ),

      Section('circular-progress: determinate', CircularProgress(0.7)),

      Section(
        'circular-progress: indeterminate',
        CircularProgress().indeterminate(true)
      ),

      Section(
        'circular-progress: custom color',
        CircularProgress().indeterminate(true).theme({ primaryColor: 'red' })
      ),

      Section(
        'circular-progress: custom four color',
        CircularProgressFourColor().indeterminate(true)
      )
        .style('--mdc-circular-progress-bar-color-1', '#2196f3')
        .style('--mdc-circular-progress-bar-color-2', '#e91e63')
        .style('--mdc-circular-progress-bar-color-3', '#ffc107')
        .style('--mdc-circular-progress-bar-color-4', '#03dac5')
    );
  },
});
